import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const ReferralDecisionPage = () => {
  const { id } = useParams();

  const [referral, setReferral] = useState(null);
  const [loading, setLoading] = useState(true);
  const [decisionLoading, setDecisionLoading] = useState(false);
  const [done, setDone] = useState(null); // accepted | rejected

  const fetchReferral = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/referrals/${id}`
      );
      setReferral(res.data.referral);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReferral();
  }, []);

  const handleDecision = async (type) => {
    try {
      setDecisionLoading(true);

      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/referrals/${id}/${type}`
      );

      setDone(type);
    } catch (err) {
      console.error(err);
    } finally {
      setDecisionLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        Loading referral...
      </div>
    );
  }

  if (!referral) {
    return (
      <div className="h-screen flex items-center justify-center">
        Referral not found
      </div>
    );
  }

  if (done) {
    return (
      <div className="h-screen flex flex-col items-center justify-center text-center px-6">
        <h2 className="text-xl font-semibold text-[#1E0E62]">
          {done === "accept" ? "Accepted ✅" : "Declined ❌"}
        </h2>
        <p className="text-sm text-gray-500 mt-2">
          The doctor and patient have been notified.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F7F8F0] flex justify-center px-4 py-6">

      <div className="w-full max-w-md space-y-6">

        {/* HEADER */}
        <div className="text-center">
          <h1 className="text-xl font-semibold text-[#1E0E62]">
            Patient Referral
          </h1>
          <p className="text-xs text-gray-500">
            Review and accept or decline
          </p>
        </div>

        {/* CARD */}
        <div className="bg-white rounded-2xl shadow-sm p-4 space-y-4">

          <div>
            <p className="text-xs text-gray-400">Patient</p>
            <p className="text-sm font-medium">
              {referral.patientId?.name || "Unknown"}
            </p>
          </div>

          <div>
            <p className="text-xs text-gray-400">Diagnosis</p>
            <p className="text-sm">
              {referral.diagnosis || "-"}
            </p>
          </div>

          <div>
            <p className="text-xs text-gray-400">Clinical Notes</p>
            <p className="text-sm">
              {referral.clinicalNotes || "-"}
            </p>
          </div>

          {referral.medications?.length > 0 && (
            <div>
              <p className="text-xs text-gray-400">Medications</p>
              <ul className="text-sm space-y-1">
                {referral.medications.map((m, i) => (
                  <li key={i}>• {m}</li>
                ))}
              </ul>
            </div>
          )}

        </div>

        {/* ACTIONS */}
        <div className="flex gap-3">

          <button
            onClick={() => handleDecision("decline")}
            disabled={decisionLoading}
            className="flex-1 py-3 rounded-xl bg-gray-200 text-gray-700 font-medium"
          >
            Decline
          </button>

          <button
            onClick={() => handleDecision("accept")}
            disabled={decisionLoading}
            className="flex-1 py-3 rounded-xl bg-[#25DAC5] text-white font-semibold shadow"
          >
            {decisionLoading ? "Processing..." : "Accept"}
          </button>

        </div>

      </div>
    </div>
  );
};

export default ReferralDecisionPage;